// extracted by mini-css-extract-plugin
export var dropdown = "_tg-0";
export var imageWrapper = "_tg-3";
export var itemNameContainer = "_tg-1";
export var productImage = "_tg-2";
export var spinnerWrapper = "_tg-4";